import React, { useState } from 'react';
import { Avatar } from "@fluentui/react-components";
import { X } from "lucide-react";
import Styles from '../AiProjectCharter.module.scss';
import Phone from "../../../components/controls/input/phoneInput/PhoneInput";
import { isValidEmail } from "../../../utils/formValidation";
import Input from "../../../components/controls/input/customInput/CustomInput";

const ContactField = ({ label, value, onChange, isMultiple = false, placeholder = "Click to add contact" }) => {
  const [editing, setEditing] = useState(false);
  const [tempName, setTempName] = useState('');
  const [tempEmail, setTempEmail] = useState('');
  const [tempPhone, setTempPhone] = useState('');
  const [newContactErrors, setNewContactErrors] = useState({});
  
      const handleContactEmailChange = (email) =>{
        setTempEmail(email)
        setNewContactErrors((prevErrors) => ({
          ...prevErrors,
          email: "",
        }));
      }

      const ValidateNewContact = () => {
        let errors = {};
      
        if (
          (!tempName|| tempName.trim().length === 0) &&
          (!tempEmail || tempEmail.trim().length === 0) &&
          (!tempPhone || tempPhone.trim().length === 0)
      ) {
          errors.name = " ";
          errors.email = " ";
          errors.phone = " ";
        }
      
        if (tempEmail && tempEmail.trim().length > 0 && !isValidEmail(tempEmail)) {
          errors.email = "Invalid Email";
        }
  
      
        setNewContactErrors(errors);
        return Object?.keys(errors)?.length > 0;
      };

  const handleSave = () => {
    if(ValidateNewContact()) return;
    if (tempName || tempEmail || tempPhone) {
      const newContact = {
        name: tempName,
        email: tempEmail,
        phone: tempPhone
      };
      
      if (isMultiple) {
        onChange([...(value || []), newContact]);
      } else {
        onChange(newContact);
      }
      
      setTempName('');
      setTempEmail('');
      setTempPhone('');
      setEditing(false);
    }
  };

  const handleRemove = (index) => {
    if (isMultiple) {
      const newValue = value.filter((_, i) => i !== index);
      onChange(newValue);
    } else {
      onChange(null);
    }
  };

  const formatContactDisplay = (contact) => {
    if (!contact) return placeholder;
    return contact.name || contact.email || contact.phone || 'Unknown';
  };

  const contacts = isMultiple ? (value || []) : (value ? [value] : []);

  return (
    <div className={Styles.ContactField}>
      <label className="text-xsm-600 grey10Color">{label}</label>
      
      <div className={Styles.ContactList}>
        {contacts.map((contact, index) => (
          <div key={index} className={Styles.ContactChip}>
            <Avatar 
              color="colorful" 
              name={contact.name || contact.email} 
              size={24}
            />
            <span className="text-sm-400">{formatContactDisplay(contact)}</span>
            <button 
              className={Styles.ContactRemove}
              onClick={() => handleRemove(index)}
            >
              <X size={14} />
            </button>
          </div>
        ))}
        
        {(!contacts.length || isMultiple) && !editing && (
          <button 
            className={Styles.AddContactBtn}
            onClick={() => setEditing(true)}
          >
            <span className="text-sm-400">+ Add {contacts.length > 0 ? 'another' : 'contact'}</span>
          </button>
        )}
      </div>

      {editing && (
        <div className={Styles.ContactEditor}>
          <div className='flex row justify-content-between align-items-end mb-2'>
            <div className='col-4'>
              <Input
                  icon={false}
                  value={tempName}
                  type="text"
                  handleChange={(e) => setTempName(e)}
                  label="Name"
                  errorMessage={newContactErrors["name"]}
                  inputClass={Styles.ContactInput}
              />
            </div>
            <div className='col-4'>
              <Input
                icon={false}
                value={tempEmail}
                type="email"
                errorMessage={newContactErrors["email"]}
                handleChange={handleContactEmailChange}
                label="Email"
                inputClass={Styles.ContactInput}
            />
            </div>
            <div className='col-4'>
            <Phone
              label="Phone"
              errorMessage={newContactErrors["phone"]}
              handleChange={(v) => {setTempPhone(v)}}
              value={tempPhone}
          />
            </div>
          </div>
          <div className={Styles.ContactEditorActions}>
            <button 
              className={Styles.ContactSaveBtn}
              onClick={handleSave}
            >
              Save
            </button>
            <button 
              className={Styles.ContactCancelBtn}
              onClick={() => {
                setEditing(false);
                setTempName('');
                setTempEmail('');
                setTempPhone('');
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactField;
